export default "\n{% block sw_cms_block_text_teaser %}\n<div class=\"sw-cms-block-text-teaser\">\n    <slot name=\"content\"></slot>\n</div>\n{% endblock %}\n";